"use strict";
import { getValidAddress } from "utils/addresses";
export function unchecksumDismissedTokenWarningKeys(state) {
  if (!state?.tokens?.dismissedTokenWarnings) {
    return state;
  }
  const newDismissedWarnings = Object.entries(state.tokens.dismissedTokenWarnings).reduce(
    (acc, [chainId, warningsForChain]) => ({
      ...acc,
      [chainId]: Object.entries(warningsForChain).reduce((chainAcc, [address, warning]) => {
        const lowercasedAddress = getValidAddress(address, false);
        return lowercasedAddress ? { ...chainAcc, [lowercasedAddress]: warning } : chainAcc;
      }, {})
    }),
    {}
  );
  return {
    ...state,
    tokens: {
      ...state.tokens,
      dismissedTokenWarnings: newDismissedWarnings
    }
  };
}
